import { base } from "./base";

export const en = { ...base };
